import { render, staticRenderFns } from "./GlobalDelinquentBanner.vue?vue&type=template&id=d4b37e54&"
import script from "./GlobalDelinquentBanner.vue?vue&type=script&lang=ts&"
export * from "./GlobalDelinquentBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports